import { createElement, lazy, type ReactElement } from 'react';
import { newsIdFromPath } from './news';

/**
 * #6402 N2 — the page App.tsx renders for `/news/:id` (pages[] matches exact paths only).
 * Kept out of App.tsx so a unit test can check the wiring without rendering the app.
 */
export const NewsIssuePage = lazy(() =>
  import('../pages/NewsIssuePage').then((m) => ({ default: m.NewsIssuePage }))
);

export interface NewsPageEntry {
  name: string;
  path: string;
  component: ReactElement;
  actions: never[];
}

/** The newsletter issue page for this path, or null when the path is not `/news/:id`. */
export function newsPageFor(currentPath: string): NewsPageEntry | null {
  const id = newsIdFromPath(currentPath);
  if (!id) return null;
  return { name: 'Newsletter Issue', path: currentPath, component: createElement(NewsIssuePage, { id }), actions: [] };
}
